import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import styles from '../Dashboards.mod.less';
import Spinner from '../../common/Spinner';
import $ from 'jquery';
import buildPrintView, {
  alignPivotTableCells,
} from 'javascripts/bookmarks/buildPrintView';
import { useAhaPanelContents, useHtmlSnapshot } from '../hooks';
import AhaContents from './AhaContents';
import customElementBoolAttr from 'javascripts/util/customElementBoolAttr';

const Pivot = ({ panel, preview, fullScreen, bookmarkId, filters }) => {
  const ahaContents = useAhaPanelContents({
    panel,
    bookmarkId,
    preview,
    showLegend: panel.showLegend,
    dashboardFilter: panel.dashboardFilter,
    filters,
  });
  const panelContentRef = useRef(null);
  const shouldUseHtmlSnapshot = useHtmlSnapshot();

  useEffect(() => {
    if (ahaContents || shouldUseHtmlSnapshot) {
      const table = $(panelContentRef.current).find('.custom-pivot-table');
      if (table) {
        buildPrintView(table);
        alignPivotTableCells(table);
      }
    }
  }, [ahaContents, fullScreen, shouldUseHtmlSnapshot]);

  let panelContent;
  if (ahaContents || shouldUseHtmlSnapshot) {
    panelContent = <AhaContents ahaContents={ahaContents} height={'100%'} />;
  } else {
    panelContent = <Spinner />;
  }

  const isLoading = !ahaContents && !shouldUseHtmlSnapshot;

  return (
    <div
      className={styles.PanelContent}
      ref={panelContentRef}
      data-async-loading={customElementBoolAttr(isLoading)}
    >
      {panelContent}
    </div>
  );
};

const mapStateToProps = state => ({
  bookmarkId: state.getIn(['meta', 'bookmarkId']),
  filters: state.getIn(['meta', 'filters']),
});

export default connect(mapStateToProps)(Pivot);
